import React, { useState } from 'react';
import { api } from '../api';
import Modal from './ui/Modal';

export default function ModalEmailPendente({ onClose }) {
  const [email, setEmail] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const salvar = async (e) => {
    e.preventDefault();
    if (salvando) return;
    if (!email.trim() || !email.includes('@')) {
      setErro('Informe um email válido.');
      return;
    }
    setErro('');
    setSalvando(true);
    try {
      await api.cadastrarEmail(email.trim());
      localStorage.removeItem('emailPendente');
      onClose();
    } catch (err) {
      setErro(err.message || 'Erro ao salvar email.');
    } finally {
      setSalvando(false);
    }
  };

  return (
    // Aviso obrigatório: sem email o login novo não funciona, então segue sem
    // botão de fechar e sem Escape (bloqueado), como era antes.
    // O invólucro só preserva o empilhamento acima dos avisos flutuantes.
    <div style={{ position: 'relative', zIndex: 9999 }}>
      <Modal titulo="Cadastre seu email" largura="380px" bloqueado onClose={onClose}>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.6, margin: '0.75rem 0 1rem' }}>
          Para maior segurança, agora o login é feito com email e senha.
          Cadastre seu email para continuar usando o AgriGest normalmente.
        </p>
        {erro && <div className="msg msg-error" style={{ marginBottom: '0.75rem' }}>{erro}</div>}
        <form onSubmit={salvar}>
          <div style={{ marginBottom: '1.25rem' }}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="seuemail@exemplo.com"
              required
              autoFocus
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button type="submit" className="btn-primary" disabled={salvando}>
              {salvando ? 'Salvando...' : 'Salvar email'}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
